import mitt from 'mitt';

import { CustomEvents } from './events-models';

const emitter = mitt<CustomEvents>();
export default emitter;
